<user-login-or-register [showRegister]="true"></user-login-or-register>
